import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useUser } from "../../../../context/AuthContext";

function ViewPartner({ inputData, data, viewData, setViewData, handleEdit }) {
  const { user } = useUser();

  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    if (data) {
      setFilteredData(data);
    }
  }, [data]);

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={() => setViewData(false)} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          Value Chain Partner Details
        </Typography>
        <Box>
          {/* <Grid item xs={12} sm={6} sx={{ mb: 2, display: "flex", gap: 3 }}> */}
          <Box sx={{ flex: 1, mb: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "bold",
                color: "#000",
                mb: 0.5,
              }}
            >
              Date
            </Typography>

            {/* Value */}
            <Typography variant="body1" sx={{ color: "#555" }}>
              {filteredData?.createdAt
                ? new Date(filteredData.createdAt).toLocaleDateString()
                : "-"}
            </Typography>
          </Box>

          <Box sx={{ flex: 1, mb: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "bold",
                color: "#000",
                mb: 0.5,
              }}
            >
              Value Chain Partner Name
            </Typography>

            {/* Value */}
            <Typography variant="body1" sx={{ color: "#555" }}>
              {filteredData?.partnerCompany?.companyName ||
                filteredData?.newPartnerName}
            </Typography>
          </Box>
          {/* </Grid> */}

          {/* Render other fields */}
          {/* {inputData.map((input, index) => { */}
          {inputData
            .filter((input) => input.fieldName !== "partner") // Filter out the "partner" field
            .map((input, index) => {
              let value = filteredData?.[input.fieldName];

              if (
                input.fieldName === "contactNumber" &&
                typeof value === "object"
              ) {
                const { countryCode, mobileNo } = value || {};
                value = `${countryCode ?? ""} ${mobileNo ?? ""}`.trim() || "-";
              }

              // Skip rendering if value is undefined or null
              if (value === undefined || value === null) return null;

              // For Address, Email, and Materials/Services, span the entire row
              if (
                input.fieldName === "address" ||
                input.fieldName === "email" ||
                input.fieldName === "materialsOrServices"
              ) {
                return (
                  <Grid item xs={12} key={input.fieldName} sx={{ mb: 2 }}>
                    {/* Heading */}
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: "bold",
                        color: "#000",
                        mb: 0.5,
                      }}
                    >
                      {input.title}
                    </Typography>

                    {/* Data */}
                    <Typography variant="body1" sx={{ color: "#555" }}>
                      {value ?? "-"}
                    </Typography>
                  </Grid>
                );
              }

              // For other fields, display in two columns
              return (
                <Grid item xs={6} key={input.fieldName} sx={{ mb: 2 }}>
                  {/* Heading */}
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: "bold",
                      color: "#000",
                      mb: 0.5,
                    }}
                  >
                    {input.title}
                  </Typography>

                  {/* Data */}
                  <Typography variant="body1" sx={{ color: "#555" }}>
                    {value ?? "-"}
                  </Typography>
                </Grid>
              );
            })}
        </Box>

        {user?.companyAdmin ? null : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10%",
            }}
          >
            <Button
              variant="contained"
              sx={{ backgroundColor: "#0a3f73", textTransform: "none" }}
              onClick={handleEdit}
            >
              Edit
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => setViewData(false)}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default ViewPartner;
